/**
 * autocreated commitinfo by @push.rocks/commitinfo
 */
export const commitinfo = {
  name: 'agl',
  version: '32.12.0',
  description: 'Agent Gateway Layer for OpenCode, FlexHarness, and Codex sessions'
}
